import { END_POINT_NAME } from '../consts/common/endpoint';
import { API_MODE, apiCommon } from '@meteor/frontend-core';

const APIList = {
  getCustomizeLayoutData: apiCommon(END_POINT_NAME.EDGE_API, '/api/customize-layout/fetch'),
  getExcelTableData: apiCommon(END_POINT_NAME.EDGE_API, '/api/customize-layout/excel-table'),
  getPromptData: apiCommon(END_POINT_NAME.EDGE_API, '/api/customize-layout/prompt'),
  getWelcomeData: apiCommon(END_POINT_NAME.EDGE_API, '/api/customize-layout/welcome'),
  getMenuData: apiCommon(END_POINT_NAME.EDGE_API, '/api/customize-layout/menus'),
  getFilterData: apiCommon(END_POINT_NAME.EDGE_API, '/api/customize-layout/filter'),
  getChatSessionList: apiCommon(END_POINT_NAME.WSS_END_POINT, 'chat-session-list', API_MODE.WEBSOCKET),

  // calender
  getCalender: apiCommon(END_POINT_NAME.EDGE_API, '/api/get-calender'),
  // Header
  getHeader: apiCommon(END_POINT_NAME.WSS_END_POINT, 'asklit/v1/header', API_MODE.WEBSOCKET),
  // forecast
  getForecastChartData: apiCommon(END_POINT_NAME.WSS_END_POINT, 'asklit/v1/kpiData', API_MODE.WEBSOCKET),
  getForecastTableData: apiCommon(END_POINT_NAME.WSS_END_POINT, 'asklit/v1/drillDownData', API_MODE.WEBSOCKET),
  // compare
  getCompareChartData: apiCommon(END_POINT_NAME.WSS_END_POINT, 'asklit/v1/compareChart', API_MODE.WEBSOCKET),
  getCompareTableData: apiCommon(END_POINT_NAME.WSS_END_POINT, 'asklit/v1/compareTable', API_MODE.WEBSOCKET),
  // risk
  getRiskChartData: apiCommon(END_POINT_NAME.WSS_END_POINT, 'asklit/v1/riskChart', API_MODE.WEBSOCKET),
  getRiskTableData: apiCommon(END_POINT_NAME.WSS_END_POINT, 'asklit/v1/riskTable', API_MODE.WEBSOCKET),
  // toshiba
  getVersion: apiCommon(END_POINT_NAME.WSS_END_POINT_TOSHIBA, 'toshiba/v1/version', API_MODE.WEBSOCKET),
  getTopData: apiCommon(END_POINT_NAME.WSS_END_POINT_TOSHIBA, 'toshiba/v1/topData', API_MODE.WEBSOCKET),
  getChangeData: apiCommon(END_POINT_NAME.WSS_END_POINT_TOSHIBA, 'toshiba/v1/changeData', API_MODE.WEBSOCKET),
  getTicketData: apiCommon(END_POINT_NAME.WSS_END_POINT_TOSHIBA, 'toshiba/v1/ticket', API_MODE.WEBSOCKET),
  getDiffData: apiCommon(END_POINT_NAME.WSS_END_POINT_TOSHIBA, 'toshiba/v1/diff', API_MODE.WEBSOCKET),
};
export default APIList;
